import { StationNavigator } from '@app/components/base/stations/StationNavigator';
import { useYoutubeNativeStations } from '@app/core/stations/hooks/useYoutubeNativeStations';
import { useStationsStore } from '@app/core/stations/stores';
import { Station, useRouter } from '@mi-front/core';

interface YoutubeNativeStationNavigatorProps {
  activeId: Station['id'];
  basePath: string;
}

/**
 * Station navigator scoped to YouTube Native stations only.
 */
export function YoutubeNativeStationNavigator({
  activeId,
  basePath,
}: YoutubeNativeStationNavigatorProps) {
  const { history } = useRouter();
  const stations = useYoutubeNativeStations();
  const recentStationIds = useStationsStore((state) => state.recentStationIds);

  const handleSelectStation = (station: Station) => {
    history.push(`/${basePath.replace(/^\//, '')}/s/${station.slug}`);
  };

  return (
    <StationNavigator
      activeId={activeId}
      stations={stations}
      recentStationIds={recentStationIds}
      onSelectStation={handleSelectStation}
    />
  );
}
